import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { useNavigate, Link } from "react-router-dom";
import brand from "../assets/img/brand.png"
import Menus from "./menus";
import Brand from "./brand";
import key from '../assets/img/key.png';
import email from '../assets/img/email.png';
import sms from '../assets/img/sms.png'
import TemplateKey from "./TemplateKey";
import EmailConfig from "./EmailConfig";
import TemplateKeyImg from "../assets/img/templatekey.png";
import EmailConfigImg from "../assets/img/emailconfig.png";
import SmsConfigImg from "../assets/img/smsconfig.png";
import SmsTemplateImg from "../assets/img/smstemplate.png";
import EmailTemplateImg from "../assets/img/emailtemplate.png";
import SmsConfig from "./SmsConfig";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import SmsTemplate from "./SmsTemplate";
import EmailTemplate from "./EmailTemplate";

import NoInternet from "./Nointernet";



function GlobalConfiguration() {
  const history = useNavigate();
  const [activeTab, setActiveTab] = useState("tab1");
  const [showMobileSubMenu, setShowMobileSubMenu] = useState(false)
 
  const [reset, setReset] = useState(0);

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    console.log("useEffect Local storage name", storedUsername)
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
        if(myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin"){
          history('/GlobalConfiguration');
          return
        }else{
            history('/Dashboard');
            return
        } 
        
      }else{
        history('/Dashboard');
        console.log("useEffect Local storage Yes")
        return
      }  
    }
    else if (storedUsername === null) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  const handleTabChange = (tab) => {
    console.log("Initial Tab", tab)
    localStorage.setItem("lastTabGlobal", tab)
    setActiveTab(tab);
  };

  useEffect(() => {
    localStorage.setItem("lastTabApproval", "tab1")
    localStorage.setItem("lastTabManagent", "tab1")
    const lastTab = localStorage.getItem("lastTabGlobal");
    if (!lastTab) {
      setActiveTab("tab1")
    }
    else {
      console.log(lastTab, "lastTTT")
      setActiveTab(lastTab)
    }

  }, [])

  //   useEffect(()=>{
  //     localStorage.setItem("lastTab","tab1")
  //     localStorage.setItem("lastTabApproval","tab1")
  //     const lastTab = localStorage.getItem("lastTabManagent");
  //     if(!lastTab){
  //       setActiveTab("tab1")}
  //     else{
  //     setActiveTab(lastTab)
  //     }

  //   },[])
  useEffect(()=>{

  })

  return (
    <>
      <Menus />
      <section className="tabular_intergration">
        <div className="tab-container">
          <div className="UnderBox-Shadow">
            <div className="container-fluid py-0 px-0">
              <div className="row">
                <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
                  <div className="tabs">
                    <button
                      className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab1")}
                    >
                      <img src={brand} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Vehicle Brands
                    </button>
                    <button
                      className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab2")}
                    >
                      <img src={TemplateKeyImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Template Key
                    </button>
                    <button
                      className={activeTab === "tab3" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab3")}
                    >
                      <img src={EmailConfigImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Email Config
                    </button>
                    <button
                      className={activeTab === "tab4" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab4")}
                    >
                      <img src={SmsConfigImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Sms Config
                    </button>
                    {/* <button
                      className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab5")}
                    >
                      <img src={AppSettingImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Application Settings
                    </button> */}
                    <button
                      className={activeTab === "tab6" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab6")}
                    >
                      <img src={SmsTemplateImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Sms Template
                    </button>
                    <button
                      className={activeTab === "tab7" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab7")}
                    >
                      <img src={EmailTemplateImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Email Template
                    </button>
                    {/* <button
                      className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab2")}
                    >
                      <img src={company} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Company
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mobileViewSubMenu" style={{width:"100%"}}>
        <div className="rebon" onClick={() => { setShowMobileSubMenu(!showMobileSubMenu) }}>
          {showMobileSubMenu === false && <FaChevronDown className="rebonChevron" size="12px" />}
          {showMobileSubMenu === true && <FaChevronUp className="rebonChevron" size="12px" />}
        </div>
        <div className={`submenu ${showMobileSubMenu ? "open" : "closed"}`}>
          <div className="row">
            <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
            <div className="tabs">
                    <button
                      className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab1")}
                    >
                      <img src={brand} className="img" style={{ width: "21px" }} />{" "}
                      Vehicle Brands
                    </button>
                    <button
                      className={activeTab === "tab2" ? "active-tab" : ""}
                      onClick={() => handleTabChange("tab2")}
                    >
                      <img src={key} className="img" style={{ width: "20px" }} /> Template Key
                    </button>
                    <button
                      className={activeTab === "tab3" ? "active-tab" : ""}
                      onClick={() => handleTabChange("tab3")}
                    >
                      <img src={email} className="img" style={{ width: "20px" }} /> Email Config
                    </button>
                    <button
                      className={activeTab === "tab4" ? "active-tab" : ""}
                      onClick={() => handleTabChange("tab4")}
                    >
                      <img src={sms} className="img" style={{ width: "20px" }} /> Sms Config
                    </button>
                    {/* <button
                      className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab5")}
                    >
                      <img src={sms} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Application Settings
                    </button> */}
                    <button
                      className={activeTab === "tab6" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab6")}
                    >
                      <img src={sms} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Sms Template
                    </button>
                    <button
                      className={activeTab === "tab7" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab7")}
                    >
                      <img src={sms} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Email Template
                    </button>
                    
                  </div>
            </div>
          </div>
        </div>
      </div>
      <div class="OneClr_apply">
        <div className="container-fluid">
          <div className='row'>
            <div className="col-12 ">


              {activeTab === "tab1" && (
                <div>
                    <Brand />
                </div>
              )}
              {activeTab === "tab2" && (
                <div>
                    <TemplateKey />
                </div>
              )}

              {activeTab === "tab3" && (
                <div>
                    <EmailConfig />
                </div>
              )}
              {activeTab === "tab4" && (
                <div>
                    <SmsConfig />
                </div>
              )}
              
              {activeTab === "tab6" && (
                <div>
                    <SmsTemplate />
                </div>
              )}
              {activeTab === "tab7" && (
                <div>
                    <EmailTemplate />
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default GlobalConfiguration;
